import React, { useState } from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { Divider, Flex, Textarea } from '@mantine/core';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { CollapseRaterInputProps } from '.';
import RadioInput, { RadioOption } from './RadioInput';
import { Controller } from 'react-hook-form';

const radioOptions: RadioOption[] = [
  {
    value: '1',
    label: 'Strongly Disagree (1)'
  },
  {
    value: '2',
    label: 'Disagree (2)'
  },
  {
    value: '3',
    label: 'Slightly Disagree (3)'
  },
  {
    value: '4',
    label: 'Slightly Agree (4)'
  },
  {
    value: '5',
    label: 'Agree (5)'
  },
  {
    value: '6',
    label: 'Strongly Agree (6)'
  }
];

const CollapseRaterInput: React.FC<CollapseRaterInputProps> = ({
  data,
  control,
  errors,
  type,
  notesExpectation,
  title
}) => {
  const [isCollapse, setIsCollapse] = useState<boolean>(true);

  const handleCollapse = () => {
    setIsCollapse(!isCollapse);
  };

  const handleDescription = (score: number) => {
    switch (score) {
      case 1:
        return 'Strongly Disagree (1)';
      case 2:
        return 'Disagree (2)';
      case 3:
        return 'Slightly Disagree (3)';
      case 4:
        return 'Slightly Agree (4)';
      case 5:
        return 'Agree (5)';
      case 6:
        return 'Strongly Agree (6)';
      default:
        return '';
    }
  };

  const filterNotesByTitle = (notesExpectation: any[], title: string) => {
    const titleToJenisMap: { [key: string]: string } = {
      Reliability: 'R1',
      Assurance: 'A',
      Tangibles: 'T',
      Empathy: 'E',
      Responsiveness: 'R2'
    };

    const jenis = titleToJenisMap[title];

    return notesExpectation.filter((note) => note.jenis === jenis);
  };

  return (
    <section className="collapse-rater-input-container">
      <Flex
        className={`collapse-rater-input-container__header ${
          isCollapse && 'open'
        }`}
        justify={'space-between'}
        align={'center'}
      >
        <Flex direction={'column'}>
          <h5 className="collapse-rater-input-container__header_title m-0">
            {title} {`(${data.length})`}
          </h5>
          <p className="collapse-rater-input-container__header_description m-0">
            Ability to perform promised service dependably and accurately
          </p>
        </Flex>
        <Flex align={'center'} gap={5}>
          {/* {type === 'rater' && (
            <div className="collapse-rater-input-container__header_expectation">
              <p>
                Expectation Score <strong>5</strong>
              </p>
            </div>
          )} */}
          <div
            className="collapse-rater-input-container__header_collapse-button"
            onClick={handleCollapse}
          >
            {isCollapse ? (
              <FiChevronUp size={32} />
            ) : (
              <FiChevronDown size={32} />
            )}
          </div>
        </Flex>
      </Flex>

      {isCollapse && (
        <>
          <Flex direction="column" mt={10} mb={26}>
            {data.length === 0 && (
              <Flex justify="center" align="center" direction="column">
                <p className="collapse-rater-input-container__header_description m-0">
                  No data available
                </p>
              </Flex>
            )}

            {data.length > 0 &&
              data.map((item, index) => {
                return (
                  <Controller
                    key={index}
                    control={control} // control prop from useForm hook
                    name={item.raterID}
                    render={({ field }) => (
                      <RadioInput
                        field={field}
                        name={item.raterID}
                        label={`${index + 1}. ${item.title}`}
                        description={
                          item.scoreExpectation
                            ? `Expectation Score: ${handleDescription(
                                item.scoreExpectation
                              )}`
                            : ''
                        }
                        options={radioOptions}
                        withAsterisk
                        error={
                          errors[item.raterID] &&
                          (errors[item.raterID].message as string)
                        }
                        key={index}
                      />
                    )}
                  />
                );
              })}
          </Flex>
          {notesExpectation?.length > 0 && (
            <>
              <Divider mb={10} />
              <p className="collapse-rater-input-container__header_title m-0">
                Notes Expectation
              </p>
              <Flex direction="column" mb={20}>
                {filterNotesByTitle(notesExpectation, title).map(
                  (note, index) => {
                    return (
                      <p
                        key={index}
                        className="collapse-rater-input-container__header_description m-0"
                      >
                        {note.notes === '' ? '-' : note.notes}
                      </p>
                    );
                  }
                )}
              </Flex>
            </>
          )}
          {data.length > 0 && (
            <>
              <Divider mb={10} />

              <Controller
                control={control} // control prop from useForm hook
                name={`${title}-notes`}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    label="Notes"
                    placeholder="Feel free to leave a note"
                  />
                )}
              />
            </>
          )}
        </>
      )}
    </section>
  );
};

export default CollapseRaterInput;
